import { store } from '@/store'
import { companyApi } from '@/store/services'
import { useTranslation } from 'react-i18next'
import { createSearchParams } from 'react-router-dom'
import { SelectWrapper } from '../wrapper'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

export const CompanySelector = ({ onChange, value, required = false }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})

  const loadOptions = async (search, _loadedOptions, additional) => {
    const page = additional?.page || 1

    const searchParams = createSearchParams({
      page,
      per_page: 10,
      'order[field]': 'name',
      'order[sort]': 'asc'
    })

    if (search) {
      searchParams.set('q', search)
    }

    const { companies, meta } = await store.dispatch(
      companyApi.endpoints.getCompanySelector.initiate(`?${searchParams.toString()}`)
    ).unwrap()

    const options = companies.map((c) => ({
      value: c.id,
      label: c.name
    }))

    const totalPages = meta?.pagination?.last || 1
    const hasMore = page < totalPages

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  const getCurrentCompany = async (id) => {
    try {
      const response = await store.dispatch(
        companyApi.endpoints.getCompanySelectorById.initiate(id)
      ).unwrap()

      const company = response.companySelector

      if (company && company.id && company.name) {
        setSelectedOption({
          value: company.id,
          label: company.name
        })
      } else {
        setSelectedOption(null)
      }
    } catch (error) {
      console.error('Error fetching company by ID:', error)
      setSelectedOption(null)
    }
  }

  const handleChange = (option) => {
    setSelectedOption(option)
    onChange(option)
  }

  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption.value) return

    getCurrentCompany(value)
  }, [value])

  return (
    <SelectWrapper label={t('company.one')} required={required}>
      {(styles) => (
        <AsyncPaginate
          isClearable
          value={isEmpty(selectedOption) ? null : selectedOption}
          debounceTimeout={600}
          placeholder={t('select.one')}
          loadingMessage={() => t('select.loading')}
          onChange={handleChange}
          loadOptions={loadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultAdditional={{ page: 1 }}
        />
      )}
    </SelectWrapper>
  )
}

CompanySelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
  required: PropTypes.bool
}